import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";

export default function CheckoutCancelled() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-16" data-testid="checkout-cancelled-page">
      <div className="glass rounded-3xl p-10 text-center border-amber-400/40">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-amber-400/10 flex items-center justify-center">
          <XCircle className="h-8 w-8 text-amber-400" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold mb-3">Paiement annulé</h1>
        <p className="text-zinc-300 leading-relaxed mb-8 max-w-xl mx-auto">
          Vous avez interrompu le paiement avant sa confirmation. Aucun montant n'a été débité.
          Vous pouvez réessayer à tout moment ou choisir un autre moyen de paiement.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/pricing" className="btn-primary inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg text-sm">
            <RefreshCw className="h-4 w-4" /> Réessayer
          </Link>
          <Link to="/" className="btn-ghost inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg text-sm">
            <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
